import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSessionStorageKeepingPinnedUsers } from "../utils/pinnedChallengeUsers";
import "./transaction-password.css";

export default function TransactionPassword() {
  const userData = useSelector((state) => state.account.userData);
  const dispatch = useDispatch();
  const transactionPassword = userData?.transactionPassword || "";

  // The rest of the admin keeps its fixed desktop viewport. This confirmation
  // page needs the actual device width so its mobile layout can activate.
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) return undefined;

    const previousViewport = viewportMeta.getAttribute("content");
    viewportMeta.setAttribute(
      "content",
      "width=device-width, initial-scale=1, viewport-fit=cover"
    );

    return () => {
      viewportMeta.setAttribute("content", previousViewport || "width=1024");
    };
  }, []);

  return (
    <main className="transaction-password-page">
      <section className="transaction-password-content" aria-live="polite">
        <h1 className="transaction-password-success">
          Success! Your password has been updated successfully.
        </h1>

        <p className="transaction-password-value">
          Your transaction password is{" "}
          <span>{transactionPassword}</span>.
        </p>

        <p className="transaction-password-note">
          Please remember this transaction password, from now on all
          transactions of the website can be done only with this password and
          keep one thing in mind, do not share this password with anyone.
        </p>

        <p className="transaction-password-thanks">
          Thank you, Team {window.location.hostname}
        </p>

        <div className="transaction-password-hindi" lang="hi">
          <h2 className="transaction-password-success">
            Success! आपका पासवर्ड बदला जा चुका है।
          </h2>
          <p className="transaction-password-value">
            आपका लेनदेन पासवर्ड <span>{transactionPassword}</span> है।
          </p>
          <p className="transaction-password-note">
            कृपया इस लेन-देन के पासवर्ड को याद रखें, अब से वेबसाइट के सभी
            हस्तांतरण केवल इस पासवर्ड से किए जा सकते हैं और एक बात का ध्यान
            रखें, इस पासवर्ड को किसी के साथ साझा न करें।
          </p>
          <p className="transaction-password-thanks">
            धन्यवाद, टीम {window.location.hostname}
          </p>
        </div>

        <button
          type="button"
          className="transaction-password-back"
          onClick={() => {
            clearSessionStorageKeepingPinnedUsers();
            window.location.href = "/";
            dispatch({
              type: "accountData/logOut",
              payload: {},
            });
          }}
        >
          <i className="fas fa-arrow-left" aria-hidden="true" />
          Back
        </button>
      </section>
    </main>
  );
}
